import { useState } from 'react'
import { useUsers } from '@/hooks/useUsers'
import { UserTable } from '@/features/users/UserTable'
import { UserFilters } from '@/features/users/UserFilters'
import { Pagination } from '@/components/shared/Pagination'
import type { Filters } from '@/types'

export function UsersPage() {
  const [filters, setFilters] = useState<Filters>({
    page: 1,
    limit: 20,
    sortBy: 'created_at',
    order: 'desc',
    search: '',
  })

  const { users, pagination, loading, error } = useUsers(filters)

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <h1 className="text-2xl font-bold">사용자</h1>
        <UserFilters filters={filters} onChange={setFilters} />
      </div>

      {error && (
        <div className="rounded-lg bg-destructive/10 p-4 text-destructive">
          {error}
        </div>
      )}

      <UserTable users={users} loading={loading} />

      {pagination && (
        <Pagination
          current={pagination.page}
          total={pagination.total_pages}
          onChange={(page) => setFilters({ ...filters, page })}
        />
      )}
    </div>
  )
}
